import CellLoading from "src/components/CellLoading/CellLoading";
import SettingsForm from "src/components/SettingsCell/SettingsForm";
import { Stack, Heading, Text, Divider } from "@chakra-ui/react";
import { gql } from "@apollo/client";

export const QUERY = gql`
  query SettingsQuery {
    settings {
      message
      maintenance,
      min_version,
      latest_version,
      force_update,
      change_log
    }
  }
`

export const Loading = CellLoading
export const Empty = () => <div>Empty</div>
export const Failure = ({ error }) => <div>Error: {error.message}</div>

export const Success = ({ settings }) => {
  return (
    <Stack minW={700} spacing={5}>
      <Heading size="lg">Maintenance Settings</Heading>
      <Text fontSize="sm">
        People will notified with message for schedule maintenance as per settings.
      </Text>
      <Divider borderColor="red.100" />
      {settings && <SettingsForm settings={settings} onSave={() => { }} />}
    </Stack>
  )
}
